var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import omit from 'lodash/omit';
import { LOAD_LAYOUT_REQUEST, LOAD_LAYOUT_SUCCESS, LOAD_LAYOUT_FAILURE, LOAD_STYLE_REQUEST, LOAD_STYLE_SUCCESS, LOAD_STYLE_FAILURE, SAVE_LAYOUT_REQUEST, SAVE_LAYOUT_SUCCESS, SAVE_LAYOUT_FAILURE, DROP_COMPONENT, SET_NAME, CHANGE_BG_COLOR, SELECT_GRID_COMPONENT, REMOVE_GRID_COMPONENT, OVERRIDE_STYLE, ASSIGN_OUTPUT, ASSIGN_STATE, ON_LAYOUT_CHANGE, CHANGE_PADDING, CHANGE_COMPONENT_VALUE, CHANGE_COMPONENT_MIN_MAX_VALUE, CHANGE_COLOR, LOCK_COMPONENT, ADD_IO, EDIT_IO, REMOVE_IO, LOAD_FILES_REQUEST, LOAD_FILES_SUCCESS, LOAD_FILES_FAILURE, GET_DATASET_REQUEST, GET_DATASET_SUCCESS, GET_DATASET_FAILURE, RESET_BG_COLOR, CHANGE_BG_IMAGE, RESET_BG_IMAGE, OPEN_COMPONENT_LIST, CLOSE_COMPONENT_LIST, GET_DATASETS_REQUEST, GET_DATASETS_SUCCESS, GET_DATASETS_FAILURE, GET_VIEWS_REQUEST, GET_VIEWS_SUCCESS, GET_VIEWS_FAILURE, CHANGE_VIEW_PADDING, TOGGLE_COMPONENT_EXCLUSIVE, SET_DATASET_SEPARATOR, CHANGE_DATASET_SEPARATOR_COLOR, RESET_DATASET_SEPARATOR, ENABLE_OVERRIDE_DATASET_LIST_GROUPING_HEADER, CHANGE_DATASET_LIST_GROUPING_HEADER_FIELDS, RESET_DATASET_LIST_GROUPING_HEADER_FIELDS, SET_FULLSCREEN, SET_FLOW, TOGGLE_PORTRAIT, TOGGLE_ORIENTATION, TOGGLE_FONT_SCALLING, CHANGE_DEVICE_SCALE, RESET_LAYOUT, GET_DATASET_FIELDS_REQUEST, GET_DATASET_FIELDS_SUCCESS, GET_DATASET_FIELDS_FAILURE, CHANGE_COMPONENT_DIMENSIONS, UPDATE_GROUPED_SELECTED_COMPONENTS, UPDATE_GROUP_SELECTION, GET_DATASET_ROWS_REQUEST, GET_DATASET_ROWS_SUCCESS, GET_DATASET_ROWS_FAILURE, SAVE_DATASET_NON_LIST_LAYOUT_REQUEST, SAVE_DATASET_NON_LIST_LAYOUT_SUCCESS, SAVE_DATASET_NON_LIST_LAYOUT_FAILURE, SAVE_LIST_VIEW_LAYOUT_REQUEST, UPDATE_SELECTED_TAB, ADD_COMPONENT_STATE_SELECTED_COMPONENT, UPDATE_LOGIC_SELECETD_COMPONENT_STATE, DELETE_COMPONENT_STATE, UPDATE_COMPONENT_STATE_NAME, COPY_COMPONENT_STATE, GET_DATASET_RULES_REQUEST, GET_DATASET_RULES_FAILURE, GET_DATASET_RULES_SUCCESS, OPEN_MODAL, CHANGE_CUSTOM_STYLES, CHANGE_DATASET_SEPARATOR_HEIGHT, TOGGLE_LIST_ITEM_BORDER, SET_LIST_ITEM_BORDER_PROPERTY, LOAD_STORAGE_REQUEST, LOAD_STORAGE_SUCCESS, LOAD_STORAGE_FAILURE, RESET_SLIDER_STYLE, SET_SLIDER_STYLE, CHANGE_DATASET_SLIDER_TEXT_COLOR, CHANGE_DATASET_SLIDER_TEXT_SIZE, CHANGE_DATASET_SLIDER_BACKGROUND_COLOR, CHANGE_DATASET_SLIDER_TEXT_WEIGHT, CHANGE_DATASET_SLIDER_FONT_FAMILY, SET_VIEW_DELETE_MODAL_STATE, SET_VIEW_DUPLICATE_MODAL_STATE, SET_VIEW_STATE, } from './constants';
import { SET_GLOBAL_STYLES_REQUEST, SET_GLOBAL_STYLES_SUCCESS, SET_GLOBAL_STYLES_FAILURE, } from '../../StructureBuilderPage/constants';
import services from '../../../services';
import { initialState } from './reducer';
import { createComponentCopy } from './helpers';
import { DRAGGING_ITEM_NAME } from '../../../components/ViewBuilder/constants';
var ViewService = services.ViewService, StyleService = services.StyleService, DatasetService = services.DatasetService, MediaService = services.MediaService, DatasetRuleService = services.DatasetRuleService, StorageService = services.StorageService;
export var updateGroupedSelectedComponents = function (componentId) { return ({
    type: UPDATE_GROUPED_SELECTED_COMPONENTS,
    componentId: componentId,
}); };
export var updateGroupSelection = function (componentIds) {
    if (componentIds === void 0) { componentIds = []; }
    return ({
        type: UPDATE_GROUP_SELECTION,
        componentIds: componentIds,
    });
};
export var toggleComponentExclusive = function (componentId, componentDefinition) { return ({
    type: TOGGLE_COMPONENT_EXCLUSIVE,
    componentId: componentId,
    componentDefinition: componentDefinition,
}); };
export var openComponentList = function () { return ({
    type: OPEN_COMPONENT_LIST,
}); };
export var closeComponentList = function () { return ({
    type: CLOSE_COMPONENT_LIST,
}); };
export var togglePortrait = function (portrait) { return ({
    type: TOGGLE_PORTRAIT,
    portrait: portrait,
}); };
export var changeDeviceScale = function (scale) { return ({
    type: CHANGE_DEVICE_SCALE,
    scale: scale,
}); };
export var changeCustomStyles = function (customStyle) { return ({
    type: CHANGE_CUSTOM_STYLES,
    customStyle: customStyle,
}); };
export var richTextCustomModal = function (modal) { return ({
    type: OPEN_MODAL,
    modal: modal,
}); };
export var addIO = function (io, ioType) { return ({
    type: ADD_IO,
    io: io,
    ioType: ioType,
}); };
export var assignOutput = function (componentId, value) { return ({
    type: ASSIGN_OUTPUT,
    componentId: componentId,
    value: value,
}); };
export var assignState = function (componentId, value) { return ({
    type: ASSIGN_STATE,
    componentId: componentId,
    value: value,
}); };
export var changeBgColor = function (value, override) {
    if (!override) {
        return {
            type: RESET_BG_COLOR,
            value: 'unset',
            override: override,
        };
    }
    return {
        type: CHANGE_BG_COLOR,
        value: value,
        override: override,
    };
};
export var changeBgImage = function (value, override) {
    if (!override) {
        return {
            type: RESET_BG_IMAGE,
            value: initialState.bgImage,
            override: override,
        };
    }
    return {
        type: CHANGE_BG_IMAGE,
        value: value,
        override: override,
    };
};
export var changeColor = function (componentId, field, value) { return ({
    type: CHANGE_COLOR,
    componentId: componentId,
    field: field,
    value: value,
}); };
export var changePadding = function (componentId, field, value, key) { return ({
    type: CHANGE_PADDING,
    componentId: componentId,
    field: field,
    value: value,
    key: key,
}); };
export var changeViewPadding = function (field, value) { return ({
    type: CHANGE_VIEW_PADDING,
    field: field,
    value: value,
}); };
export var dropComponent = function (component) { return ({
    type: DROP_COMPONENT,
    component: component,
}); };
export var editIO = function (id, io, ioType) { return ({
    type: EDIT_IO,
    id: id,
    io: io,
    ioType: ioType,
}); };
export var getFiles = function (scope) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, files, meta, icons, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: LOAD_FILES_REQUEST });
                return [4 /*yield*/, MediaService.getFiles(scope)];
            case 1:
                _a = _b.sent(), files = _a.objects, meta = _a.meta;
                icons = files.filter(function (file) { return file.mime_type === 'image/svg+xml'; });
                dispatch({ type: LOAD_FILES_SUCCESS, files: files, icons: icons, meta: meta });
                return [3 /*break*/, 3];
            case 2:
                err_1 = _b.sent();
                dispatch({ type: LOAD_FILES_FAILURE, err: err_1 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var loadStorage = function (app) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var localStorage_1, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: LOAD_STORAGE_REQUEST });
                return [4 /*yield*/, StorageService.fetchStorage(app)];
            case 1:
                localStorage_1 = (_a.sent()).objects;
                dispatch({
                    type: LOAD_STORAGE_SUCCESS,
                    localStorage: localStorage_1,
                });
                return [3 /*break*/, 3];
            case 2:
                err_2 = _a.sent();
                dispatch({
                    type: LOAD_STORAGE_FAILURE,
                    err: err_2,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var lockComponent = function (componentId, value) { return ({
    type: LOCK_COMPONENT,
    componentId: componentId,
    value: value,
}); };
export var onLayoutChange = function (layout) { return ({
    type: ON_LAYOUT_CHANGE,
    vbLayout: layout,
}); };
export var removeGridComponent = function (componentId) { return ({
    type: REMOVE_GRID_COMPONENT,
    componentId: componentId,
}); };
export var removeIO = function (id, ioType) { return ({
    type: REMOVE_IO,
    id: id,
    ioType: ioType,
}); };
export var selectGridComponent = function (componentId) { return ({
    type: SELECT_GRID_COMPONENT,
    componentId: componentId,
}); };
export var setName = function (name) { return ({
    type: SET_NAME,
    name: name,
}); };
export var changeComponentValue = function (componentId, e, field, fieldType) {
    if (field === 'showIfEmpty' && !e.target) {
        return {
            type: CHANGE_COMPONENT_VALUE,
            componentId: componentId,
            fieldType: fieldType,
            field: field,
            value: e,
            fieldValueType: 'string',
        };
    }
    var _a = e.target, value = _a.value, checked = _a.checked, type = _a.type;
    var number = Number(value);
    var newValue = (function (valueType) {
        switch (valueType) {
            case 'text':
                return value;
            case 'data':
                return value;
            case 'select-one':
                return value;
            case 'number':
                return number;
            case 'checkbox':
                return checked;
            default:
                return value === null || Number.isNaN(number) ? value : number;
        }
    })(type);
    return {
        type: CHANGE_COMPONENT_VALUE,
        componentId: componentId,
        fieldType: fieldType,
        field: field,
        value: newValue,
        fieldValueType: type,
    };
};
export var changeComponentMinMaxValue = function (componentId, e, field, fieldType, minMaxValue) { return ({
    type: CHANGE_COMPONENT_MIN_MAX_VALUE,
    componentId: componentId,
    value: Number(e.target.value),
    field: field,
    fieldType: fieldType,
    minMaxValue: minMaxValue,
}); };
export var getStyle = function (id) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var style, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: LOAD_STYLE_REQUEST,
                });
                dispatch({
                    type: SET_GLOBAL_STYLES_REQUEST,
                });
                return [4 /*yield*/, StyleService.getStyle(id, false)];
            case 1:
                style = (_a.sent()).object;
                dispatch({
                    type: LOAD_STYLE_SUCCESS,
                    style: style,
                });
                dispatch({
                    type: SET_GLOBAL_STYLES_SUCCESS,
                    style: style,
                });
                return [3 /*break*/, 3];
            case 2:
                err_3 = _a.sent();
                dispatch({ type: LOAD_STYLE_FAILURE, err: err_3 });
                dispatch({
                    type: SET_GLOBAL_STYLES_FAILURE,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var handleOverrideStyle = function (componentId, defaultStyle, checked) { return ({
    type: OVERRIDE_STYLE,
    componentId: componentId,
    checked: checked,
}); };
export var loadLayout = function (id) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, meta, viewData, err_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: LOAD_LAYOUT_REQUEST });
                return [4 /*yield*/, ViewService.getView(id)];
            case 1:
                _a = _b.sent(), meta = _a.meta, viewData = _a.object;
                dispatch({
                    type: LOAD_LAYOUT_SUCCESS,
                    payload: __assign(__assign({}, viewData), { meta: meta }),
                });
                return [3 /*break*/, 3];
            case 2:
                err_4 = _b.sent();
                console.error(err_4);
                dispatch({ type: LOAD_LAYOUT_FAILURE, err: err_4 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
var omitPropsFromLayout = function (layout) {
    var newLayout = [];
    layout
        .filter(function (c) { return c.i !== DRAGGING_ITEM_NAME && c.i !== 'undefined' && c.i !== 'null'; })
        .forEach(function (component) {
        var comp = omit(__assign(__assign({}, layout.find(function (c) { return c.i === component.i; })), component), [
            'isDraggable',
            'isResizable',
            'moved',
            'boundingRect',
            'index',
            'getDiffs',
            'setDiffs',
            'icon',
            'maxH',
            'maxW',
            'minH',
            'minW',
            'style',
            'jsx',
        ]);
        newLayout.push(comp);
    });
    return newLayout.reduce(function (previous, current) {
        previous[current.i] = current;
        return previous;
    }, {});
};
export var getDatasets = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var datasets, err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: GET_DATASETS_REQUEST });
                return [4 /*yield*/, DatasetService.listDatasets(appId)];
            case 1:
                datasets = (_a.sent()).objects;
                dispatch({ type: GET_DATASETS_SUCCESS, datasets: datasets });
                return [3 /*break*/, 3];
            case 2:
                err_5 = _a.sent();
                dispatch({ type: GET_DATASETS_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getDatasetRules = function (datasetId, appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var datasetRules, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: GET_DATASET_RULES_REQUEST, datasetId: datasetId });
                return [4 /*yield*/, DatasetRuleService.fetchDatasetRules(datasetId, appId)];
            case 1:
                datasetRules = (_a.sent()).objects;
                dispatch({
                    type: GET_DATASET_RULES_SUCCESS,
                    datasetRules: datasetRules,
                });
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                dispatch({
                    type: GET_DATASET_RULES_FAILURE,
                    error: error_1,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getViews = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var views, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: GET_VIEWS_REQUEST });
                return [4 /*yield*/, ViewService.getViews(appId)];
            case 1:
                views = (_a.sent()).objects;
                dispatch({ type: GET_VIEWS_SUCCESS, views: views });
                return [3 /*break*/, 3];
            case 2:
                err_6 = _a.sent();
                dispatch({ type: GET_VIEWS_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getDatasetFields = function (datasetId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var datasetData, err_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: GET_DATASET_FIELDS_REQUEST });
                return [4 /*yield*/, DatasetService.getColumns(datasetId)];
            case 1:
                datasetData = (_a.sent()).object;
                dispatch({ type: GET_DATASET_FIELDS_SUCCESS, fields: datasetData.fields });
                return [3 /*break*/, 3];
            case 2:
                err_7 = _a.sent();
                dispatch({ type: GET_DATASET_FIELDS_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getDatasetData = function (datasetId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, meta, datasetData, err_8;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                dispatch({ type: GET_DATASET_REQUEST });
                return [4 /*yield*/, DatasetService.getColumns(datasetId)];
            case 1:
                _a = _d.sent(), meta = _a.meta, datasetData = _a.object;
                dispatch({
                    type: GET_DATASET_SUCCESS,
                    fields: datasetData.fields,
                    layout: (datasetData.view_options.list
                        ? datasetData.view_options.list.layout
                        : datasetData.view_options.layout) || {},
                    background_color: datasetData.view_options.list
                        ? datasetData.view_options.list.background_color
                        : datasetData.view_options.background_color,
                    background_image: datasetData.view_options.list
                        ? datasetData.view_options.list.background_image
                        : datasetData.view_options.background_image,
                    separator: (datasetData.view_options.list &&
                        datasetData.view_options.list.separator) ||
                        false,
                    separatorColor: (datasetData.view_options.list &&
                        datasetData.view_options.list.separatorColor) ||
                        'unset',
                    groupingHeader: datasetData.view_options.list &&
                        datasetData.view_options.list.groupingHeader,
                    sliderStyle: (_b = datasetData === null || datasetData === void 0 ? void 0 : datasetData.view_options) === null || _b === void 0 ? void 0 : _b.list.sliderStyle,
                    sliderOption: (_c = datasetData === null || datasetData === void 0 ? void 0 : datasetData.view_options) === null || _c === void 0 ? void 0 : _c.list.sliderOption,
                    padding: datasetData.view_options.list && datasetData.view_options.list.padding,
                    meta: meta,
                    dataset: datasetData,
                });
                return [3 /*break*/, 3];
            case 2:
                err_8 = _d.sent();
                console.error(err_8);
                dispatch({ type: GET_DATASET_FAILURE, err: err_8 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var saveDatasetLayout = function (datasetId, datasetData, style) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var savedLayout, background_color, err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: SAVE_LAYOUT_REQUEST });
                savedLayout = omitPropsFromLayout(datasetData.view_options.list.layout);
                background_color = datasetData.view_options.list.background_color;
                if (style && style.data) {
                    if (background_color === style.data.backgroundColor) {
                        background_color = 'unset';
                    }
                }
                datasetData.view_options.list = __assign(__assign({}, datasetData.view_options.list), { layout: savedLayout, background_color: background_color });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, DatasetService.updateDataset(datasetId, datasetData)];
            case 2:
                _a.sent();
                dispatch({ type: SAVE_LAYOUT_SUCCESS });
                return [2 /*return*/, true];
            case 3:
                err_9 = _a.sent();
                dispatch({ type: SAVE_LAYOUT_FAILURE, err: err_9 });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, false];
        }
    });
}); }; };
export var saveLayoutForCalendarAndMap = function (datasetId, datasetData) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: SAVE_DATASET_NON_LIST_LAYOUT_REQUEST,
                    payload: datasetData,
                });
                return [4 /*yield*/, DatasetService.updateDataset(datasetId, datasetData)];
            case 1:
                _a.sent();
                dispatch({ type: SAVE_DATASET_NON_LIST_LAYOUT_SUCCESS });
                return [3 /*break*/, 3];
            case 2:
                err_10 = _a.sent();
                dispatch({ type: SAVE_DATASET_NON_LIST_LAYOUT_FAILURE, err: err_10 });
                console.error(err_10);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getDatasetRows = function (datasetId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var datasetRows, err_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: GET_DATASET_ROWS_REQUEST });
                return [4 /*yield*/, DatasetService.getRows(datasetId)];
            case 1:
                datasetRows = (_a.sent()).objects;
                dispatch({ type: GET_DATASET_ROWS_SUCCESS, datasetRows: datasetRows });
                return [3 /*break*/, 3];
            case 2:
                err_11 = _a.sent();
                dispatch({ type: GET_DATASET_ROWS_FAILURE });
                console.error(err_11);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var updateViewName = function (props) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ViewService.updateViewName(__assign({}, props))];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                err_12 = _a.sent();
                console.error(err_12);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var saveLayout = function (props) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var layout, savedLayout, bgColor, settings, err_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: SAVE_LAYOUT_REQUEST });
                layout = props.layout;
                savedLayout = omitPropsFromLayout(layout);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                bgColor = props.bgColor;
                settings = {
                    accessibility: props.accessibility,
                    fullscreen: props.fullscreen,
                    flow: props.flow,
                    hasLandscape: props.hasLandscape,
                    fontScalingAllowed: props.fontScalingAllowed,
                    calendar: props.calendar,
                    map: props.map,
                    grid: props.grid,
                    sliderStyle: props.sliderStyle,
                    sliderOption: props.sliderOption,
                };
                if (props.type === 'list') {
                    settings.separator = props.separator;
                    settings.separatorColor = props.separatorColor;
                    settings.separatorHeight = props.separatorHeight;
                    settings.groupingHeader = props.groupingHeader;
                    settings.enableListItemBorder = props.enableListItemBorder;
                    settings.listItemBorder = props.listItemBorder;
                }
                delete props.type;
                if (!((props === null || props === void 0 ? void 0 : props.name) !== '')) return [3 /*break*/, 3];
                return [4 /*yield*/, ViewService.updateView(__assign(__assign({}, props), { savedLayout: savedLayout, bgColor: bgColor, settings: settings }))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                dispatch({ type: SAVE_LAYOUT_SUCCESS });
                return [2 /*return*/, true];
            case 4:
                err_13 = _a.sent();
                dispatch({ type: SAVE_LAYOUT_FAILURE, err: err_13 });
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, false];
        }
    });
}); }; };
export var enableSeparator = function (value) { return ({
    type: value ? SET_DATASET_SEPARATOR : RESET_DATASET_SEPARATOR,
}); };
export var changeSeparatorColor = function (value) { return ({
    type: CHANGE_DATASET_SEPARATOR_COLOR,
    value: value,
}); };
export var enableSliderOptions = function (value) { return ({
    type: value ? SET_SLIDER_STYLE : RESET_SLIDER_STYLE,
}); };
export var changeTitleTextSize = function (value) { return ({
    type: CHANGE_DATASET_SLIDER_TEXT_SIZE,
    value: value,
}); };
export var changeSliderTitleFontWeight = function (value) { return ({
    type: CHANGE_DATASET_SLIDER_TEXT_WEIGHT,
    value: value,
}); };
export var changeSliderFontFamily = function (value) { return ({
    type: CHANGE_DATASET_SLIDER_FONT_FAMILY,
    value: value,
}); };
export var changeSliderTitleColor = function (value) { return ({
    type: CHANGE_DATASET_SLIDER_TEXT_COLOR,
    value: value,
}); };
export var changeSliderBackgroundColor = function (value) { return ({
    type: CHANGE_DATASET_SLIDER_BACKGROUND_COLOR,
    value: value,
}); };
export var changeSeparatorHeight = function (value) { return ({
    type: CHANGE_DATASET_SEPARATOR_HEIGHT,
    value: value,
}); };
export var toggleListItemBorder = function () { return ({
    type: TOGGLE_LIST_ITEM_BORDER,
}); };
export var setListItemBorderProperty = function (property, value) { return ({
    type: SET_LIST_ITEM_BORDER_PROPERTY,
    property: property,
    value: value,
}); };
export var enableOverrideDatasetListGroupingHeader = function (value) { return ({
    type: ENABLE_OVERRIDE_DATASET_LIST_GROUPING_HEADER,
    value: value,
}); };
export var changeDatasetListGroupingHeaderFields = function (field, value, override) { return ({
    type: override
        ? CHANGE_DATASET_LIST_GROUPING_HEADER_FIELDS
        : RESET_DATASET_LIST_GROUPING_HEADER_FIELDS,
    field: field,
    value: value,
    override: override,
}); };
export var enableFullscreen = function (value) { return ({
    type: SET_FULLSCREEN,
    value: value,
}); };
export var enableFlow = function (value) { return ({
    type: SET_FLOW,
    value: value,
}); };
export var enableOrientation = function (value) { return ({
    type: TOGGLE_ORIENTATION,
    value: value,
}); };
export var allowFontScaling = function (value) {
    return {
        type: TOGGLE_FONT_SCALLING,
        value: value,
    };
};
export var setListViewLayout = function (layoutData, listType) { return ({
    type: SAVE_LIST_VIEW_LAYOUT_REQUEST,
    layoutData: layoutData,
    listType: listType,
}); };
export var resetLayout = function () { return ({
    type: RESET_LAYOUT,
}); };
export var changeComponentDimensions = function (componentId, field, value) { return ({
    type: CHANGE_COMPONENT_DIMENSIONS,
    componentId: componentId,
    field: field,
    value: value,
}); };
export var pasteComponent = function (component) { return function (dispatch) {
    var newComponent = createComponentCopy(component);
    if (newComponent) {
        dispatch(dropComponent(newComponent));
    }
}; };
// multi state component actions
export var selectComponentPropertyTab = function (tab) {
    if (tab === void 0) { tab = 'default'; }
    return function (dispatch) {
        dispatch({
            type: UPDATE_SELECTED_TAB,
            tab: tab,
        });
    };
};
export var addComponentStateToLayout = function (state, props) { return function (dispatch) {
    dispatch({
        type: ADD_COMPONENT_STATE_SELECTED_COMPONENT,
        state: state,
        props: props,
    });
}; };
export var addLogicToComponentState = function (logic) {
    if (logic === void 0) { logic = {}; }
    return function (dispatch) {
        dispatch({
            type: UPDATE_LOGIC_SELECETD_COMPONENT_STATE,
            logic: logic,
        });
    };
};
export var removeComponentState = function (state) {
    if (state === void 0) { state = ''; }
    return function (dispatch) {
        dispatch({
            type: DELETE_COMPONENT_STATE,
            state: state,
        });
        dispatch({
            type: UPDATE_SELECTED_TAB,
            tab: 'default',
        });
    };
};
export var updateStateName = function (oldName, newName) {
    if (oldName === void 0) { oldName = ''; }
    if (newName === void 0) { newName = ''; }
    return function (dispatch) {
        dispatch({
            type: UPDATE_COMPONENT_STATE_NAME,
            old: oldName,
            new: newName,
        });
    };
};
export var copyComponentState = function (state) {
    if (state === void 0) { state = ''; }
    return function (dispatch) {
        dispatch({
            type: COPY_COMPONENT_STATE,
            state: state,
        });
    };
};
export var setViewDeleteModalState = function (state) { return function (dispatch) {
    dispatch({
        type: SET_VIEW_DELETE_MODAL_STATE,
        state: state,
    });
}; };
export var setViewDuplicateModalState = function (state) { return function (dispatch) {
    dispatch({
        type: SET_VIEW_DUPLICATE_MODAL_STATE,
        state: state,
    });
}; };
